export default "__VITE_ASSET__6342967e__"